import React, {useEffect} from "react";
import {Card, Container, Grid, Typography} from "@mui/material";
import styles from "../assets/css/lastPosts.module.scss";
import {Link} from "react-router-dom";

const LastPosts = (props) => {

    useEffect(()=>{
    })
    return <div className={styles.container}>
        <Container maxWidth={"lg"}>
            <Typography variant={"h5"} className={styles.title}>{props.title}</Typography>
            <div className={styles.itemsContainer}>
                <Grid container>
                    {props.content.map((item,index) => <Item {...item} key={index}/>)}

                </Grid>
            </div>
        </Container>
    </div>;
};

const Item = (props) => {
    return <Grid item md={4} xs={12}>
        <Card elevation={3} className={styles.item}>
            <Typography className={styles.itemTitle} variant={"body2"} component={"p"}>{props.title}</Typography>
            <Typography variant={"subtitle2"} component={"p"} >{props.description}</Typography>
            <div className={styles.linkContainer}>
                <Link className={styles.link} to={`/blog/${props.id}`}>اطلاعات بیشتر</Link>

            </div>
        </Card>
    </Grid>
}

export default LastPosts;